import script from "./PortfoliosPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfoliosPage.vue?vue&type=script&setup=true&lang=ts"

import "./PortfoliosPage.vue?vue&type=style&index=0&id=744eb490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744eb490"]])

export default __exports__